import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";

console.log("bundle.ts");

//
document.addEventListener("DOMContentLoaded", () => {
	initDefaultSwiperCenteredSlides("#top_kv_swiper", {
		speed: 1000,
		autoplay: {
			delay: 5000,
		},
		slidesPerViewForPC: 2,
		slidesPerViewForSP: 1.2,
		// spaceBetweenForPC: 30,
		// spaceBetweenForSP: 20,
		spaceBetweenForPC: 0,
		spaceBetweenForSP: 0,
	} as SwiperOptionCustomize);

	initDefaultSwiperCenteredSlides("#top_avp_swiper", {
		speed: 1000,
		autoplay: {
			delay: 5000,
		},
		slidesPerViewForPC: 2,
		slidesPerViewForSP: 1.2,
		// spaceBetweenForPC: 30,
		// spaceBetweenForSP: 20,
		spaceBetweenForPC: 0,
		spaceBetweenForSP: 0,
	} as SwiperOptionCustomize);

	initDefaultSwiperCenteredSlides("#beginner_operation_kv_swiper", {
		speed: 1000,
		isAutoPlay: false,
		slidesPerViewForPC: 2,
		slidesPerViewForSP: 1.2,
		// spaceBetweenForPC: 30,
		// spaceBetweenForSP: 20,
		spaceBetweenForPC: 0,
		spaceBetweenForSP: 0,
	} as SwiperOptionCustomize);
});

type SwiperOptionCustomize = {
	speed?: number;
	autoplay?: {
		delay: number;
	};
	slidesPerViewForPC: number;
	slidesPerViewForSP: number;
	spaceBetweenForPC: number;
	spaceBetweenForSP: number;
};
/**
 * swiperのCenteredSlidesのカスタマイズが毎回やることが増えたので関数化
 * @param selector 対象要素のセレクタ
 */
const initDefaultSwiperCenteredSlides = (
	selector: string,
	swiperOptionCustomize: SwiperOptionCustomize,
) => {
	const swiperElementList = document.querySelectorAll(selector);
	if (swiperElementList.length === 0) {
		return;
	}

	/**
	 * spと判定するメディアクエリ
	 */
	const spMediaQueryStr = "(max-aspect-ratio: 7/10)";
	/**
	 * ナビゲーション要素　のセレクタ
	 */
	const selectorNavWrap = "[data-slider-nav-wrap]";
	/**
	 * カスタムページネーションアイテム 独自のページネーションを使う場合だけ使用する
	 */
	const selectorCustomPaginationItem = "[data-slider-custom-pagination-item]";

	/**
	 * swiperのdefaultページネーション要素のセレクタ
	 */
	const defaultPagination = ".swiper-pagination";
	const speed = swiperOptionCustomize.speed;
	const autoplay = swiperOptionCustomize.autoplay;

	const slidesPerViewForPC = swiperOptionCustomize.slidesPerViewForPC;
	const slidesPerViewForSP = swiperOptionCustomize.slidesPerViewForSP;
	const spaceBetweenForPC = swiperOptionCustomize.spaceBetweenForPC;
	const spaceBetweenForSP = swiperOptionCustomize.spaceBetweenForSP;

	const initMain = (swiperElement: Element) => {
		console.log("initDefaultSwiperCenteredSlides initMain");
		// 対象になる要素が存在しない場合は処理を中断

		if (!(swiperElement instanceof HTMLElement)) {
			return;
		}

		const swiperItems = swiperElement.querySelectorAll(".swiper-slide");

		console.log("swiperElement", swiperElement);

		console.log("swiperItems", swiperItems);
		const swiperAreaEl = swiperElement.parentElement;
		console.log("swiperAreaEl", swiperAreaEl);
		if (!swiperAreaEl) {
			return;
		}

		/**
		 * swiperのdefaultページネーション要素
		 */
		const defaultPaginationEl = swiperAreaEl.querySelector(defaultPagination);

		/**
		 * ナビゲーション要素
		 */
		const sliderNavWrap = swiperAreaEl.querySelector(
			selectorNavWrap,
		) as HTMLElement;
		console.log("sliderNavWrap", sliderNavWrap);

		const prevEl = sliderNavWrap?.querySelector(
			"[data-swiper-button-prev]",
		) as HTMLElement;
		const nextEl = sliderNavWrap?.querySelector(
			"[data-swiper-button-next]",
		) as HTMLElement;
		console.log("prevEl", prevEl);
		console.log("nextEl", nextEl);

		/**
		 * カスタムページネーションアイテム要素
		 */
		const customPaginationItems = swiperAreaEl?.querySelectorAll(
			selectorCustomPaginationItem,
		) as NodeListOf<HTMLElement> | null;

		const slidesPerViewMax =
			slidesPerViewForPC > slidesPerViewForSP
				? slidesPerViewForPC
				: slidesPerViewForSP;

		/** swiperのバグなのか画面に表示する数がギリギリだと右側が消えてしまうので対策 */
		const minimumSlidesCount = slidesPerViewMax + 2;

		const defaultSlideCount = swiperItems.length;

		const slidesTimes = Math.ceil(minimumSlidesCount / swiperItems.length);
		console.log("slidesTimes", slidesTimes);
		const newCount = swiperItems.length * slidesTimes;
		console.log("newCount", newCount);

		const getActiveCustomNavIndex = (index: number) => {
			console.log("getActiveCustomNavIndex", index);
			if (defaultSlideCount === 0) return 0;
			// 本来のindexを求める
			if (index + 1 <= defaultSlideCount) return index;
			const realIndex = (index + 1) % defaultSlideCount;
			// console.log("getActiveCustomNavIndex realIndex", realIndex);
			return realIndex === 0 ? defaultSlideCount - 1 : realIndex - 1;

			// return realIndex - 1;
		};
		// swiperItemsの数がminimumSlidesCountより少ない場合は、swiperItemsの数をslidesPerViewMaxにする、順番は保持する
		if (swiperItems.length < minimumSlidesCount) {
			const numberOfClonesNeeded =
				Math.ceil(minimumSlidesCount / swiperItems.length) *
					swiperItems.length -
				swiperItems.length;

			const clonedItems = [] as Node[];
			for (let i = 0; i < numberOfClonesNeeded; i++) {
				const cloneIndex = i % swiperItems.length;
				const clonedItem = swiperItems[cloneIndex].cloneNode(true);
				clonedItems.push(clonedItem);
			}
			const target = swiperElement.querySelector(".swiper-wrapper");
			if (target !== null) {
				console.log("clonedItems", clonedItems);
				clonedItems.forEach((clonedItem) => {
					target.appendChild(clonedItem);
				});
			}
		}

		const params = {
			// 以下のモジュールを使う
			// modules: [Navigation, Pagination, Autoplay, EffectFade],
			modules: [Navigation, Pagination, Autoplay, EffectFade],

			loop: true,
			speed: speed,
			slidesPerView: slidesPerViewForPC,
			centeredSlides: true,
			spaceBetween: spaceBetweenForPC,
			on: {
				init: function () {
					if (
						customPaginationItems &&
						customPaginationItems instanceof HTMLElement
					) {
						// 初期スライドに対応するナビゲーションアイテムに.is_activeを追加
						const initialNavItem = customPaginationItems.firstElementChild;
						if (initialNavItem) {
							customPaginationItems.classList.add("is_active");
						}
					}
				},
				slideChange: function () {
					// スライドが変わるたびに.is_activeを更新
					updateNavigationActiveClass(this.realIndex);
					console.log("slideChange activeIndex:", this.realIndex);
				},
			},
		};

		if (autoplay) {
			Object.assign(params, {
				autoplay: autoplay,
			});
		}

		// sliderNavWrapが存在する場合だけparamsにnavigationプロパティを動的に追加
		if (sliderNavWrap) {
			Object.assign(params, {
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
				},
			});
		}
		if (defaultPaginationEl) {
			Object.assign(params, {
				pagination: {
					el: defaultPaginationEl,
					clickable: true,
				},
			});
		}

		const mySwiper = new Swiper(swiperElement, params);

		const resizeNav = () => {
			console.log("resizeNav");
			if (!mySwiper.slides[0]) return;
			if (!prevEl) return;
			if (!nextEl) return;
			console.log("resizeNav");
			var slide = mySwiper.slides[0];
			var width = slide.offsetWidth;
			var height = slide.offsetHeight;
			if (sliderNavWrap) {
				sliderNavWrap.style.height = height + "px";
				sliderNavWrap.style.width = width + "px";
				const prevElWidth = getComputedStyle(prevEl).width;
				const nextElWidth = getComputedStyle(nextEl).width;
				console.log("prevElWidth", prevElWidth);
				const spaceBetween = window.matchMedia(spMediaQueryStr).matches
					? spaceBetweenForSP
					: spaceBetweenForPC;
				prevEl.style.left = `calc(-1 * ((${prevElWidth} / 2) + (${spaceBetween}px / 2) ))`; // アイコンの幅半分からマージンの幅/2を引く
				nextEl.style.right = `calc(-1 * ((${nextElWidth} / 2) + (${spaceBetween}px / 2) ))`; // アイコンの幅半分からマージンの幅/2を引く
			}
		};

		// spでサイズが設定できない問題の対応
		mySwiper.on("resize", function () {
			handleResize();
		});

		// デバウンス関数
		const debounce = (func: (...args: any[]) => void, wait: number) => {
			let timeout: number | undefined;

			return (...args: any[]) => {
				const later = () => {
					clearTimeout(timeout);
					func(...args);
				};

				clearTimeout(timeout);
				timeout = window.setTimeout(later, wait);
			};
		};

		// リサイズイベントのハンドラ
		const handleResize = () => {
			// console.log("リサイズイベントが発火しました。");
			// ここにリサイズ時に行いたい処理を記述
			resizeNav();
			if (window.matchMedia(spMediaQueryStr).matches) {
				// スマホの比率の場合のパラメータ変更
				mySwiper.params.slidesPerView = slidesPerViewForSP;
				mySwiper.params.spaceBetween = spaceBetweenForSP;
				// スマホの比率の場合の処理があればここに記述
			} else {
				// PCの比率の場合のパラメータ変更
				mySwiper.params.slidesPerView = slidesPerViewForPC;
				mySwiper.params.spaceBetween = spaceBetweenForPC;
				// PCの比率の場合の処理があればここに記述
			}
			mySwiper.update();
		};

		// デバウンス関数を使用してリサイズイベントリスナーを設定
		window.addEventListener("resize", debounce(handleResize, 250));

		// カスタムページネーションアイテムのクリックイベント
		customPaginationItems?.forEach((element, index) => {
			element.addEventListener("click", function () {
				console.log("customPaginationItems click index:", index);
				mySwiper.slideToLoop(index);
				// クリックされたナビゲーションアイテムに.is_activeを追加
				element.classList.add("is_active");
				// それ以外から.is_activeを削除
				const siblings = element.parentElement?.querySelectorAll(
					selectorCustomPaginationItem,
				);
				siblings?.forEach((sibling) => {
					if (sibling !== element) {
						sibling.classList.remove("is_active");
					}
				});
			});
		});

		// slideと連動した.is_activeクラスの更新関数
		function updateNavigationActiveClass(activeIndex) {
			if (customPaginationItems) {
				const realIndex = getActiveCustomNavIndex(activeIndex);
				customPaginationItems.forEach((element, index) => {
					if (index === realIndex) {
						element.classList.add("is_active");
					} else {
						element.classList.remove("is_active");
					}
				});
			}
		}
		handleResize(); // ページ読み込み時にも実行
	};

	swiperElementList.forEach((swiperElement) => {
		initMain(swiperElement);
	});
};

const initTopStoreList = () => {
	if (document.getElementById("top_store_list") === null) return;

	const forDeleteItems = document.querySelectorAll(
		"#top_store_list_normal .common_store_item",
	) as NodeListOf<HTMLElement>;
	const showMoreButton = document.getElementById(
		"top_store_list_show_more",
	) as HTMLElement | null;
	// 初期表示設定
	let hideStartIndex = 6; // 7件目以降を非表示にする

	// itemsでdata-is-recommendを持つ要素を削除
	forDeleteItems.forEach((item: HTMLElement, index) => {
		if (
			item?.dataset.isRecommend === "true" ||
			item.hasAttribute("data-top-none")
		) {
			item.remove();
		}
	});
	const items = document.querySelectorAll(
		"#top_store_list_normal .common_store_item",
	) as NodeListOf<HTMLElement>;
	// アイテムの初期表示を制御
	items.forEach((item: HTMLElement, index) => {
		// console.log("index", index);
		if (index >= hideStartIndex) {
			item.classList.add("is_hide"); // 7件目以降に.is_hideを追加
		}
	});
	if (showMoreButton !== null) {
		// もっと見るボタンのクリックイベント
		showMoreButton.addEventListener("click", function () {
			items.forEach((item) => {
				item.classList.remove("is_hide"); // 全アイテムから.is_hideを削除
			});
			showMoreButton.style.display = "none"; // ボタンを非表示にする
		});
	}
};

document.addEventListener("DOMContentLoaded", () => {
	initTopStoreList();
});

window.addEventListener("load", () => {});
